import React from 'react';
import './event-mangement-main-content.css'
import AddCTA from '../component/common/addcta';
import pic24 from '../assets/pic24.png'
import pic25 from '../assets/pic25.png'
import pic26 from '../assets/pic26.png'
import pic27 from '../assets/pic27.png'
import pic28 from '../assets/pic28.png'
import pic29 from '../assets/pic29.png'
import Header2 from '../component/common/title';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Input from '../component/common/input';
import Cta from '../component/common/cta';
import pic30 from '../assets/pic30.png'
import Textarea from '../component/common/textarea';
import Selectinput from '../component/common/selectinput';
import pic31 from '../assets/pic31.png'
import SubpageCTA from '../component/common/subpagecta';
import pic54 from '../assets/pic54.png'
import pic55 from '../assets/pic55.png'
import Errormsginput from '../component/common/errormsginput';

const Eventmanagemntcontent = () => {

const [search, setSearch] = useState('');
const [filter, setFilter] = useState('');
const [sort, setSort] = useState('');

const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 6;


         const [event, setEvent]= useState([]);

        useEffect(() => {
        const getevent = async()=>{
            const res = await supabase.from('exbition_event').select('*').order('id', { ascending: true });;
        setEvent(res.data);
        }
        getevent();
        }, []);




const filteredEvents = event
    .filter((item) =>
        item.event_name?.toLowerCase().includes(search.toLowerCase())
    )
    .filter((item) => {
        if (!filter) return true;

        return item.status === filter;
    })
    .sort((a, b) => {
        if (sort === "newest") {
            return new Date(b.start_date) - new Date(a.start_date);
        }
        if (sort === "oldest") {
            return new Date(a.start_date) - new Date(b.start_date);
        }
        return 0;
    });


useEffect(() => {
  setCurrentPage(1);
}, [search, filter, sort]);



const totalPages = Math.ceil(filteredEvents.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const currentEvents = filteredEvents.slice(startIndex, endIndex);









// this is my create function

const [open, setOpen] = useState(false);

const [form, setForm] = useState({
  event_name: "",
  start_date: "",
  end_date: "",
  location: "",
  status: "upcoming",
  time: "",
  description: "",
  lat: "",
  lng: "",
  img: ""
});


const [errors, setErrors] = useState({});


// this is my deleete function
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedDeleteId, setSelectedDeleteId] = useState(null);

const confirmDelete = async () => {
  const id = selectedDeleteId;

      await supabase.from('timetable_section_repeated_sections').delete().eq('exbition_id', id);
    await supabase.from('ticket').delete().eq('event_id', id);
  await supabase.from('bookings').delete().eq('event_id', id);
        // await supabase.from('exhibitors').delete().eq('event_id', id);
  await supabase.from('exbition_event_exhibitors').delete().eq('event_exhibitors_id', id);

  await supabase.from('exbition_event').delete().eq('id', id);

  setEvent(prev => prev.filter(event => event.id !== id));

  setShowDeleteModal(false);
  setSelectedDeleteId(null);
};




// this is my editt function
const [isEdit, setIsEdit] = useState(false);
const [editingId, setEditingId] = useState(null);







// dah el edit we el create

const handleSubmit = async (e) => {
  e.preventDefault();
  const newErrors = {};

  if (!form.event_name.trim()) {
  newErrors.event_name = "Event name is required";}

    if (!form.start_date) {
    newErrors.start_date = "Start date is required";}

    if (!form.end_date) {
    newErrors.end_date = "End date is required";}

    if (!form.location.trim()) {
    newErrors.location = "Location is required";}

    if (!form.time.trim()) {
    newErrors.time = "Time is required";}

    if (!form.description.trim()) {
    newErrors.description = "Description is required";}

    if (!form.lat) {
    newErrors.lat = "Latitude is required";}
    if (!form.lng) {
    newErrors.lng = "Longitude is required";}

    if (!form.img.trim()) {
    newErrors.img = "Image URL is required";}


setErrors(newErrors);

    if (
    newErrors.event_name ||
    newErrors.start_date ||
    newErrors.end_date ||
    newErrors.location ||
    newErrors.time ||
    newErrors.description ||
    newErrors.lat ||
    newErrors.lng ||
    newErrors.img
    ) {return;}


  const missing =
    !form.event_name ||
    !form.start_date ||
    !form.end_date ||
    !form.location;

  if (missing) {
    alert("Some fields are missing, but event will still be created");
  }

  const payload = {
    event_name: form.event_name,
    start_date: form.start_date,
    end_date: form.end_date,
    location: form.location,
    status: form.status || "upcoming",
    time: form.time || null,
    description: form.description || null,
    lat: form.lat ? Number(form.lat) : null,
    lng: form.lng ? Number(form.lng) : null,
    img: form.img || null
  };

  let query;

  if (editingId) {
    query = supabase.from("exbition_event").update(payload).eq("id", editingId);
  } else {
    query = supabase.from("exbition_event").insert([payload]);
  }

  const { error } = await query;

  if (error) {
    console.log(error.message);
    return;
  }

  const res = await supabase
    .from("exbition_event")
    .select("*")
    .order("id", { ascending: true });

  setEvent(res.data);

  setForm({
    event_name: "",
    start_date: "",
    end_date: "",
    location: "",
    status: "upcoming",
    time: "",
    description: "",
    lat: "",
    lng: "",
    img: ""
  });
setErrors({});
  setEditingId(null);
  setOpen(false);
};















    return ( 

    <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Events Management"  
                            para="Manage all your events and ticket listings."
                            />
                            
                          <AddCTA    title='Add Event'   onClick={() => {
                                    setEditingId(null);
                                    setOpen(true);
                                }}  />
                     
                            {open && (
                                <form className="overlay-create" onSubmit={handleSubmit}>
                                    <fieldset className="container-create">

                                    <div class="header-create">
                                        <h1 className="title-create">
                                        {editingId ? "Edit Event" : "Add New Event"}
                                        </h1>
                                        <button className="close-btn-create" type="button" 
                                        onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                        <img alt="close" src={pic30}/></button>
                                        </div>

                                    <Input
                                    title='Event Name'
                                        placeholder="Enter Event Name"
                                        value={form.event_name}
                                        onChange={(e) =>
                                        setForm({ ...form, event_name: e.target.value })
                                        }
                                    />
                                    <Errormsginput message={errors.event_name} />

                                    <Input
                                                                        title='Start Date'
                                        placeholder="Enter Start Date"
                                        type="date"
                                        value={form.start_date}
                                        onChange={(e) =>
                                        setForm({ ...form, start_date: e.target.value })
                                        }
                                    />

                                    <Errormsginput message={errors.start_date} />


                                    <Input
                                      title='End Date'
                                      placeholder="Enter End Date"
                                        type="date"
                                        value={form.end_date}
                                        onChange={(e) =>
                                        setForm({ ...form, end_date: e.target.value })
                                        }
                                    />

                                    <Errormsginput message={errors.end_date} />

                                    <Input
                                    title='Location'
                                    
                                        placeholder="Enter Location"
                                        value={form.location}
                                        onChange={(e) =>
                                        setForm({ ...form, location: e.target.value })
                                        }
                                    />

                                     <Errormsginput message={errors.location} />


                                    <Selectinput
                                        title="Status"
                                        value={form.status}
                                        onChange={(e) =>
                                            setForm({ ...form, status: e.target.value })
                                        }
                                        options={[
                                            { value: "ongoing", label: "ongoing" },
                                            { value: "upcoming", label: "upcoming" },
                                            { value: "ended", label: "ended" }
                                        ]}
                                        />



                                        <Input
                                        title="Time"
                                        placeholder="Enter Time"
                                        type="text"
                                        value={form.time}
                                        onChange={(e) => setForm({ ...form, time: e.target.value })}
                                    />

                                    <Errormsginput message={errors.time} />



                                    <Textarea 
                                        stylee="main-text-area"
                                        title="Description"
                                        placeholder="Enter Description"
                                        value={form.description}
                                        onChange={(e) =>
                                            setForm({ ...form, description: e.target.value })
                                        }
                                        />

                                        <Errormsginput message={errors.description} />

                                        <Input
                                        title="Latitude"
                                        value={form.lat}
                                        placeholder="Enter Latitude"
                                        onChange={(e) =>
                                            setForm({ ...form, lat: e.target.value })
                                        }
                                        />

                                        <Errormsginput message={errors.lat} />

                                        <Input
                                        title="Longitude"
                                        value={form.lng}
                                        placeholder="Enter Longitude"
                                        onChange={(e) =>
                                            setForm({ ...form, lng: e.target.value })
                                        }
                                        />

                                        <Errormsginput message={errors.lng} />



                                        <Input
                                        title="Image URL"
                                        value={form.img}
                                        placeholder="Enter Image URL"
                                        onChange={(e) =>
                                            setForm({ ...form, img: e.target.value })
                                        }
                                        />

                                        <Errormsginput message={errors.img} />


                                    <nav className='container-ctas-craete'>
                                          <Cta
                                            title={editingId ? "Update Event" : "Save Event"}
                                            className="cta-create"
                                            type="submit"
                                            />
                                            <button className='cta-cancel-create' onClick={() => {
                                            setOpen(false);
                                            setEditingId(null);
                                            }}>
                                            <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                            </button>
                                    </nav>
                                    </fieldset>
                                </form>
                                )}  

                                
                                  
        </article>



<section className='container-table2-eventp'>
                                    <section className='container-sub-pages-part'>
                                        <nav className='container2-sub-pages-cta'>
                                            <button className='main-container-cta-subpage'>
                                                <SubpageCTA title='Events List' img={pic54} alt='booking-users'
                                                style2='cta-event-text' style1='subpagecta-event'/>
                                            </button>
                                            <button className='main-container-cta-subpage'>
                                                <SubpageCTA title='Events-Timetable' img={pic55} alt='booking-companies'
                                                style2='secsubpagecta-event-text' style1='secsubpagecta-event'/>
                                            </button>
                                        </nav>
                                    </section>



          <section className='container-table-eventp'>




                                        {showDeleteModal && (
                                                <section className="delete-modal-overlay">
                                                    <article className="delete-modal">

                                                    <header className="delete-modal-header">
                                                        <div className="delete-icon-wrapper">
                                                        <img src={pic31} alt='icon' />
                                                        </div>

                                                        <div className="delete-text-container">
                                                        <h2 className="delete-title">Delete Event</h2>
                                                        <p className="delete-description">
                                                            Are you sure you want to delete this event?
                                                        </p>
                                                        </div>
                                                    </header>

                                                    <nav className="container-ctas-craete">

                                                       <Cta 
                                                         onClick={confirmDelete}
                                                        title='Delete'
                                                       className="cta-create"
                                                       type="button" />

                                                    <button className='cta-cancel-create' 
                                                    onClick={() => {
                                                                        setShowDeleteModal(false);
                                                                        setSelectedDeleteId(null);
                                                    }}>
                                                    <h2 className='cta-cancel-text-create'>  Cancel</h2>
                                                    </button>
                                                              
                                                                
                                                    </nav>

                                                    </article>
                                                </section>
                                                )}





                            <fieldset className="input-wrapper">
                                <input 
                                  className='input-search'
                                    placeholder="Search events..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)} />
                                <img src={pic26} className="search-icon" alt="search" />
                            </fieldset>

                            <fieldset className='container-inputs-event-p'>
                                    <div className="select-wrapper">
                                                <img src={pic25} className="arrow-icon" alt="arrow" />
                                                <img src={pic26} className="select-icon" alt="filter" />
                                           <select
                                            className="input-search select-style"
                                            value={filter}
                                            onChange={(e) => setFilter(e.target.value)}
                                        >
                                            <option value="">Filter by</option>
                                            <option value="upcoming">Upcoming</option>
                                            <option value="ongoing">Ongoing</option>
                                            <option value="ended">Ended</option>
                                        </select>
                                     </div>

                                    <div className="select-wrapper">
                                        <img src={pic25} className="arrow-icon" alt="arrow" />
                                        <img src={pic24} className="select-icon" alt="sort" />
                                        <select
                                        className="input-search select-style"
                                        value={sort}
                                        onChange={(e) => setSort(e.target.value)}
                                        >
                                        <option value="">Sort by</option>
                                        <option value="newest">Sort by date (Nearly upcoming)</option>
                                        <option value="oldest">Sort by date (Long-term)</option>
                                        </select>
                                    </div>

                            </fieldset>



                             <div className="table-container" >
                                <table className='table'>
                                    <thead>
                                    <tr className='table-header'>
                                        <th className='table-header-text'></th>
                                        <th className='table-header-text'>ID</th>
                                        <th className='table-header-text'>Event Name</th>
                                        <th className='table-header-text'>start date</th>
                                        <th className='table-header-text'>End date</th>
                                        <th className='table-header-text'>Status</th>
                                        <th className='table-header-text'>Time</th>
                                        <th className='table-header-text'>Description</th>                                        
                                        <th className='table-header-text'>Location</th>
                                        <th className='table-header-text'>Image</th>
                                        <th className='table-header-text'>lat</th>  
                                         <th className='table-header-text'>Ing</th>                                                                                                                                                                                                                                             
                                        <th className='table-header-text'>Actions</th>
                                    </tr>
                                    </thead>

                                {currentEvents.map((item) => (
                                    <tbody key={item.id}>
                                            <tr className='table2-header'>
                                                <td className='checkbox-cont-table'>
                                                    <label className="custom-checkbox">
                                                    <input type="checkbox"  className='checkboxxx'/>
                                                    <span className="checkmark"></span>
                                                    </label>
                                                </td>
                                                <td className='mainwhite-table-font'>{item.id}</td>
                                                <td className='container-event-desc-long'>
                                                   {item.event_name}
                                                </td>
                                                <td className='mainwhite-table-font'> {item.start_date}</td>
                                                 <td className='mainwhite-table-font'>
                                                  {item.end_date}
                                                </td>
                                                 <td className='mainwhite-table-font'>
                                                  {item.status}
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                    {item.time}
                                                </td>
                                                 <td className="container-event-desc">
                                                <p className="truncate-text">
                                                 {item.description}
                                                </p>
                                                </td>
                                                <td className="container-event-desc">
                                                <p className="truncate-text">
                                                    {item.location}
                                                </p>
                                                </td>
                                                <figure className='mainwhite-table-font'>
                                                <img className='img-tabel-event' src= {item.img} alt='event-image'/>
                                                </figure>
                                                <td className='mainwhite-table-font'>
                                                   {item.lat}
                                                </td>

                                                <td className='mainwhite-table-font'>
                                                   {item.lng}
                                                </td>
                                                <td className='mainwhite-table-font'>
                                                    <nav className='cta-table'>

                                                            <button
                                                            className='cta2-table'
                                                            
                                                            >
                                                                <img src={pic27} alt='edit' />
                                                            </button>



                                                           <button
                                                            className='cta2-table'
                                                            onClick={() => {
                                                                setForm({
                                                                event_name: item.event_name,
                                                                start_date: item.start_date,
                                                                end_date: item.end_date,
                                                                location: item.location,
                                                                status: item.status,
                                                                time: item.time,
                                                                description: item.description,
                                                                lat: item.lat,
                                                                lng: item.lng,
                                                                img: item.img
                                                                });

                                                                setEditingId(item.id);
                                                                setIsEdit(true);
                                                                setOpen(true);
                                                            }}
                                                            >
                                                            <img src={pic28} alt='edit' />
                                                            </button>
                                                            


                                                            <button
                                                            className='cta2-table'
                                                             onClick={() => {
                                                                setSelectedDeleteId(item.id);
                                                                setShowDeleteModal(true);
                                                            }}
                                                            
                                                            >
                                                                <img src={pic29} alt='delete' />
                                                            </button>
                                                            
                                                    </nav>
                                                </td>




                                            </tr>
                                    </tbody>
                                  ))}
                                </table>
                                </div>

                                       




            </section>

            <nav className="pagination-container">

            <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}>
                Prev
            </button>

            <section className="pagination-numbers">
                {[...Array(totalPages)].map((_, index) => (<button
                    key={index}
                    className={
                    currentPage === index + 1
                        ? "pagination-number active-page"
                        : "pagination-number"
                    }
                    onClick={() => setCurrentPage(index + 1)}>
                    {index + 1}</button>
                ))}
            </section>

            <button
                className="pagination-btn"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}>
                Next
            </button>

            </nav>


    </section>
</section>

     );
}
 
export default Eventmanagemntcontent;